<template>
  <v-card :elevation="show_off == true ? '0' : '4'">
    <v-toolbar v-if="show_off != true" color="indigo" dense>
      <v-toolbar-title class="white--text">
        Configurazione Etichetta
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <!-- Bottone di salvataggio -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn small @click="salvaLabel" v-bind="attrs" v-on="on">
            <v-icon color="success"> mdi-floppy </v-icon>
          </v-btn>
        </template>
        <span>Salva</span>
      </v-tooltip>

      <v-spacer></v-spacer>

      <!-- Bottone di aumento ingrandimento -->
      <v-chip color="white" class="mr-4 py-0">
        <v-icon class="mr-1" color="primary">mdi-magnify</v-icon>
        {{ zoom }}
      </v-chip>
      <v-slider
        hide-details
        v-model="zoom"
        color="blue lighten-2"
        track-color="white"
        min="1"
        max="200"
      >
        <template v-slot:prepend>
          <v-icon @click="decrement" color="white">
            mdi-magnify-minus-outline
          </v-icon>
        </template>
        <template v-slot:append>
          <v-icon @click="increment" color="white">
            mdi-magnify-plus-outline
          </v-icon>
        </template>
      </v-slider>

      <v-spacer></v-spacer>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn small @click="goBack" v-bind="attrs" v-on="on">
            <v-icon color="error"> mdi-keyboard-backspace </v-icon>
          </v-btn>
        </template>
        <span>Indietro</span>
      </v-tooltip>
    </v-toolbar>
    <div id="mainCardText">
      <v-row>
        <v-col cols="3" v-if="show_off == true && show_tab_off == false">
          <v-card elevation="4">
            <v-toolbar dense color="indigo">
              <v-toolbar-title class="white--text">
                Campi Editabili
              </v-toolbar-title>
            </v-toolbar>
            <v-data-table
              :items-per-page="5"
              :headers="headers"
              :items="items_text_object"
            >
              <template v-slot:[`item.editabile`]="{ item }">
                <v-checkbox
                  :true-value="1"
                  :false-value="0"
                  @change="clickCheckbox"
                  dense
                  v-model="item.editabile"
                />
              </template>
            </v-data-table>
          </v-card>
        </v-col>
        <v-col>
          <v-card>
            <v-toolbar dense color="indigo">
              <v-toolbar-title class="white--text">
                Label Preview
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <!-- Bottone di aumento ingrandimento -->
              <v-chip color="white" v-if="show_off == true" class="mr-4 py-0">
                <v-icon class="mr-1" color="primary">mdi-magnify</v-icon>
                {{ zoom }}
              </v-chip>
              <v-slider
                v-if="show_off == true"
                hide-details
                v-model="zoom"
                color="blue lighten-2"
                track-color="white"
                min="1"
                max="200"
              >
                <template v-if="show_off == true" v-slot:prepend>
                  <v-icon @click="decrement" color="white">
                    mdi-magnify-minus-outline
                  </v-icon>
                </template>
                <template v-if="show_off == true" v-slot:append>
                  <v-icon @click="increment" color="white">
                    mdi-magnify-plus-outline
                  </v-icon>
                </template>
              </v-slider>
              <v-spacer></v-spacer>
            </v-toolbar>
            <div
              id="id-card-label"
              style="
                overflow-y: auto;
                margin-top: 10px;
                margin-left: 10px;
                margin-right: 10px;
                padding-bottom: 10px;
              "
            >
              <ReportPage
                @handleClickDestroTextObject="handleClickDestroTextObject"
                :src="etichetta"
                :zoom="zoom"
                @scaleH="scaleLabelH"
                :key="key_report_page"
              />
            </div>
          </v-card>
        </v-col>
      </v-row>
    </div>

    <!-- Menu contestuale -->
    <v-card
      id="menu_contestuale"
      style="position: absolute; z-index: 9999"
      v-show="menu_contestuale_visible"
      width="250px"
    >
      <v-toolbar color="indigo" dense>
        <v-toolbar-title class="white--text">
          Menu Contestuale
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              x-small
              @click="menu_contestuale_visible = false"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon small color="error"> mdi-close </v-icon>
            </v-btn>
          </template>
          <span>Chiudi</span>
        </v-tooltip>
      </v-toolbar>
      <v-list>
        <v-list-item @click="enterModEditObj">
          <v-list-item-title> Modifica Oggetto </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-card>

    <!-- Dialog di modifica degli oggetti -->
    <v-dialog v-model="modifica_dialog" width="50%">
      <ModificaOggetto
        @chiudi_dialog="handleChiudiDialogModifica"
        :elemento_sel="elemento_sel"
        @salvata_modifica="handleSalvataModifica"
        :testata="report"
        :visible="modifica_dialog"
      >
      </ModificaOggetto>
    </v-dialog>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>
<script>
// import _ from "lodash";
import Report from "@/classes/QLReport.js";
import ModificaOggetto from "@/components/QUICKLABEL/ModificaOggetto.vue";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import ReportPage from "@/components/QUICKLABEL/components_label/ReportPage.vue";
import { JsonToFrx } from "./FrxJsonConverter";

export default {
  name: "",
  components: {
    ModificaOggetto,
    SnackbarQV,
    ReportPage,
  },
  props: {
    etichetta: {
      type: Object,
      default: null,
    },
    etichetta_base64: {
      type: String,
      default: null,
    },
    campi: {
      type: Array,
      default: () => [],
    },
    id_articolo_packaging_report: {
      type: Number,
      default: null,
    },
    show_off: {
      type: Boolean,
      default: false,
    },
    show_tab_off: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // Variabili d'appoggio
      click_down_x: null,
      click_down_y: null,
      click_up_x: null,
      click_up_y: null,
      elemento_sel: new Object(),
      fattore_ingrandimento: 1,
      report: new Report(),
      zoom: 100,
      key_report_page: 0,

      // Modal
      menu_contestuale_visible: false,
      modifica_dialog: false,

      // Array
      items_text_object: [],
      headers: [
        {
          text: "Label",
          value: "text",
          sortable: false,
        },
        {
          text: "Edita",
          value: "editabile",
          sortable: false,
        },
      ],
    };
  },
  computed: {},
  watch: {
    etichetta: {
      immediate: true,
      handler() {
        this.zoom = 100;
        this.$nextTick(() => {
          this.key_report_page = this.key_report_page == 0 ? 1 : 0;
        });
        // if (this.show_off == 1) {
        //   this.getTextObject(this.etichetta);
        // }
      },
    },
  },
  methods: {
    clickCheckbox() {
      this.$emit("getItemsTextObj", this.items_text_object);
    },
    decrement() {
      this.zoom--;
    },
    increment() {
      this.zoom++;
    },
    build(tasks) {
      const result = new Array();
      const temp = new Array();
      let i,
        j,
        length = tasks.length;

      for (i = 0; i < length; i++) {
        tasks[i]._children = new Array();
        temp.push(tasks[i]);
        if (temp[i].id_padre == null) {
          result.push(temp[i]);
        }
      }

      let done = false;
      while (!done) {
        done = true;
        for (i = 0; i < length; i++) {
          let task_i = temp[i];
          if (task_i._associato != true && task_i.id_padre != null) {
            for (j = 0; j < length; j++) {
              let task_j = temp[j];
              if (
                task_j.id_articolo_packaging_report_dettaglio == task_i.id_padre
              ) {
                task_j._children.push(task_i);
                task_i._associato = true;
              }
            }
          }
          if (task_i._associato != true && task_i.id_padre != null) {
            done = false;
          }
        }
      }

      return result;
    },
    chiudiDialogModifica() {
      this.modifica_dialog = false;
    },
    enterModEditObj() {
      // Rendo invisibile il menu contestuale
      this.menu_contestuale_visible = false;

      // Rendo visibile il dialog di modifica
      this.modifica_dialog = true;
    },
    // goBack() {
    //   this.$emit("goToLista");
    // },
    handleChiudiDialogModifica() {
      this.modifica_dialog = false;
    },
    handleClickDestroTextObject(arg_obj) {
      // Se il menu era visibile lo nascondo
      // if (this.menu_contestuale_visible === true) {
      //   this.menu_contestuale_visible = false;
      // } else {
      //   // Se non era ancora visibile...
      //   // console.log(
      //   //   e.clientX -
      //   //     document.getElementById("reportPage").getBoundingClientRect().x
      //   // );
      //   // console.log(
      //   //   e.clientY -
      //   //     document.getElementById("reportPage").getBoundingClientRect().y
      //   // );
      //   // // Registro le coordiante del punto in cui ho clickato.
      //   // this.click_down_x = e.clientX;
      //   // this.click_down_y = e.clientY;
      //   // this.click_up_x = e.clientX;
      //   // this.click_up_y = e.clientY;

      //   // const rect = document
      //   //   .getElementById("reportPage")
      //   //   .getBoundingClientRect();

      //   // let computedX = Math.round(e.clientX - rect.x);
      //   // let computedY = Math.round(e.clientY - rect.y);

      //   // document.getElementById("menu_contestuale").style.left =
      //   //   computedX + "px";
      //   // document.getElementById("menu_contestuale").style.top =
      //   //   computedY + "px";

      // }
      // Copio il nodo che ho selezionato per un'eventuale modifica.
      this.elemento_sel = arg_obj.detail;

      // Rendo visibile il menun contestuale
      this.modifica_dialog = true;
    },
    handleSalvataModifica(arg) {
      this.modifica_dialog = false;

      for (let f in arg) {
        this.elemento_sel[f] = arg[f];
      }
    },
    ingrandisci() {
      let fattore_tmp = this.fattore_ingrandimento + 0.5;

      if (fattore_tmp <= 2) {
        this.fattore_ingrandimento = fattore_tmp;
      }
    },
    rimpicciolisci() {
      let fattore_tmp = this.fattore_ingrandimento - 0.5;

      if (fattore_tmp >= 0.5) {
        this.fattore_ingrandimento = fattore_tmp;
      }
    },
    salvaLabel() {
      let label_tmp = JsonToFrx(this.etichetta, this.etichetta_base64);

      // Definisco la testata per il salvataggio;
      // const testata_tmp = new Report(this.report);
      // delete testata_tmp.report;

      /* Emetto un evento per lasciare che il componente
       * padre si aggiorni e lanci la gestione della
       * chiusura del dialog del figlio.*/
      // let request = {
      //   controller: "Manutenzione",
      //   method: "PUT",
      //   richiesta: {
      //     action: "setlabel",
      //     token: localStorage.user_token,
      //     label: [testata_tmp],
      //     report: [this.report.report],
      //   },
      // };

      let request = {
        controller: "Label",
        method: "PUT",
        richiesta: {
          action: "setlabelcliente",
          token: localStorage.user_token,
          modello_report: label_tmp,
          id_articolo_packaging_report: this.id_articolo_packaging_report,
        },
      };
      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.$refs.SnackbarQV.print(
              "success",
              "Etichetta salvata con successo!"
            );
            // this.getLabel();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              `Si è verificata una criticità tecnica con codice: ${res.status}.`
            );
          }
        })
        .catch((err) => {
          this.$refs.SnackbarQV.print(
            "orange",
            `${JSON.parse(err.response.data.message).result}.`
          );
        });
    },
    styleDiv(item) {
      const map = {
        ReportPage: {
          w: "PaperWidth",
          h: "PaperHeight",
          um: "mm",
          t: "Top",
          l: "Left",
        },
        _default: { w: "Width", h: "Height", um: "px", t: "Top", l: "Left" },
      };

      if (item != null) {
        const mapItem =
          map[item._tipo] == undefined ? map._default : map[item._tipo];

        return {
          width:
            item[mapItem.w] == null ? "auto" : item[mapItem.w] + mapItem.um,
          height:
            item[mapItem.h] == null ? "auto" : item[mapItem.h] + mapItem.um,
          top: item[mapItem.t] == null ? "0" : item[mapItem.t] + mapItem.um,
          left: item[mapItem.l] == null ? "0" : item[mapItem.l] + mapItem.um,
          position: "absolute",
          border: "1px solid pink",
          textAlign: "center",
          backgroundColor: "red",
          "--tag": item._tipo ? item._tipo : "",
        };
      }
    },
    uploadImage(val, dim_x, dim_y) {
      /* Se l'argomento è nullo non faccio niente
       * (magari ho appena pulito il campo del dialog). */
      if (val === null) return;

      /* Se invece l'argomento è un'immagine, comincio a eseguire
       * la logica di salvataggio per importarla nel canvas SVG
       * e chiudo il dialog di upload dell'immagine. */

      let that = this;

      let reader = new FileReader();

      reader.onload = function () {
        // Registro l'immagine come Base64.

        let img_tmp = new Image();

        img_tmp.width = dim_x;
        img_tmp.height = dim_y;

        that.$nextTick(() => (img_tmp.src = reader.result));

        return 'url("' + img_tmp.src + '")';
      };

      reader.onerror = function (error) {
        console.log("Error: ", error);
      };

      reader.readAsDataURL(val);
    },
    getTextObject(item, result = new Array()) {
      if (item._tipo == "TextObject" && item.Text) {
        if (!item.Text.includes("[")) {
          console.log("c è la forma",item);
          result.push({
            id: item._id,
            text: item.Text,
          });
        }
      }

      item._children.forEach((i) => {
        this.getTextObject(i, result);
      });

      return result;
    },
    scaleLabelH(a) {
      document.getElementById("id-card-label").style.height = a + 20 + "px";
    },
  },
  created() {},
  mounted() {
    if (this.show_off == 1) {
      if (this.etichetta != null) {
        this.items_text_object = this.getTextObject(this.etichetta); 
      }

      // if (this.campi != null) {
      //    if (this.campi.length != 0) {
      //   this.campi.forEach((c) => {
      //     this.items_text_object.forEach((t) => {
      //       if (c.id_campo == t.id) {
      //         t.editabile = c.editabile;
      //       }
      //     });
      //   });
      // }
      // } else {
      //   this.$emit("getItemsTextObj", this.items_text_object);
      // }
     
    }

    this.styleDiv(this.etichetta);
    document
      .getElementById("mainCardText")
      .addEventListener("clickTextObject", this.handleClickDestroTextObject);
  },
};
</script>
<style scoped>
.rotated {
  transform: rotate(45deg);
}
</style>